import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Grid,
  MenuItem,
  TextField,
  Stack,
  InputLabel,
  Typography,
  Button,
  IconButton,
  Card,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { brandActions } from "../../service/brand.action";
import "../brandCrud/brand.css";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileSaver from "file-saver";
import { useTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import { blob } from "stream/consumers";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import CustomLoader from "../../../../util/component/CustomLoader";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import { IServerSideGetRowsParams } from "ag-grid-community";
import GenericFilterBox from "../common/GenericFilterBox";
import { GenericTitleHeader } from "../common/GenericTitleHeader";
import useTenant from "../../hooks/useTenant";
import { ContextOperation } from "../../context/OperationContext";
import SectionHeader from "../../../../util/component/SectionHeader";
import AgGridOperationTable from "../common/AgGridOperationTable";

const BrandCrudTable = () => {
  const { dispatchGlobalData } = useContext(GlobalContext);
  const { setLoading } = useContext(ContextOperation);
  const [gridApi, setGridApi] = useState<any>(null);
  //const [pageSize, setPageSize] = useState<number>(10);
  let pageSize = 10;
  const [length, setLength] = useState<number>(0);
  let totalElement: any = 0;
  const [resetForm, setResetForm] = useState<boolean>(false);
  const [loading, setIsLoading] = useState(false);
  const [dataForm, setData] = useState<any>({
    descr: "",
    code: "",
  });
  const { t } = useTranslation(["operation"]);
  const brandServise = brandActions();
  const {tenant} = useContext(ContextOperation);

  let code: string;
  const columns: any = [
    {
      field: "descr",
      headerName: t("carRange.description"),
      flex: 1,
    },
    {
      field: "code",
      headerName: t("carRange.code"),
      flex: 1,
    },
    {
      field: "id",
      headerName: "Id",
      disableColumnMenu: true,
      hide: true,
      headerClassName: "titleOfHeader",
      flex: 1,
      sortable: false,
    },
  ];

  const handleChange = (event: any, type: any) => {
    setData({ ...dataForm, [type]: event.target.value });
  };
  const onGridReady = (params: any) => {
    setGridApi(params.api);
  };

  function managerData(response: any) {
    let rows: any[] = [];
    response.data.content.forEach((element: any) => {
      let row = {
        code: element.code,
        descr: element.descr,
        id: element.id,
      };
      rows.push(row);
    });
    return rows;
  }

  function Search() {
    setIsLoading(true);
    let descr1 = !!dataForm.descr? dataForm.descr.trim() : null;
    let code1 = !!dataForm.code? dataForm.code.trim() : null;
    return {
      getRows: async (params: IServerSideGetRowsParams) => {
        const startRow = params.request.startRow ? params.request.startRow : 0;
        const endRow = params.request.endRow;
        
        if (endRow !== null && endRow !== undefined && startRow !== null && startRow !== undefined) {
          pageSize = endRow - startRow;
        }
        const pageNumber = startRow / pageSize
        brandServise
          .getBrandQueryParams(tenant,pageNumber, pageSize, descr1, code1)
          .then((response: any) => {
            params.successCallback(
              managerData(response),
              response.data.totalElements
            );
            
            setLength(response.data.totalElements);
            

            setIsLoading(false);
          })
          .catch((error) => {
            if (error.response) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: error.response.data.error,
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setIsLoading(false);
            } else if (error.request) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: t("networkErrorMessage"),
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setIsLoading(false);
            } else {
              setIsLoading(false);
            }
            setIsLoading(false);
          });
      },
    };
  }
  const reset = () => {
  
    setData({
      descr: "",
      code: "",
    });
    setResetForm(!resetForm);
  };

  function exportBrand() {
    let descr1 = !!dataForm.descr? dataForm.descr.trim() : null;
    let code1 = !!dataForm.code? dataForm.code.trim() : null;
    setLoading(true);
    brandServise.exportData(tenant,descr1, code1).then((response) => {
      setLoading(false);
      const filename =
        response?.headers["content-disposition"].split("filename=")[1];
      var blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver.saveAs(blob, filename);
    });
  }

  const searchBrand = (e: any) => {
    e.preventDefault();
    setResetForm(!resetForm);
  };

  useEffect(() => {
    if (gridApi) {
      gridApi.setServerSideDatasource(Search());
    }
  }, [gridApi, resetForm]);

  return (
    <Box>
      <SectionHeader
          title={t("brand.titleFirst") + " " + t("brand.titleSecond")}
      />
      <Box>
        <form id="idBrandForm" onSubmit={(e) => searchBrand(e)}>
          <GenericFilterBox
            formId="idBrandForm"
            onReset={reset}
            
          >
         
            <Box>
              <TextField
                variant="standard"
                fullWidth
                id="descr"
                name="descr"
                value={dataForm.descr}
                label={t("brand.description")}
                onChange={(event) => handleChange(event, "descr")}
                inputProps={{
                  pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                  onInput: (event) => {
                    if (event.currentTarget.validity.patternMismatch) {
                      event.currentTarget.setCustomValidity(
                        t("vehicle.filterModal.regexMessage")
                      );
                    } else {
                      event.currentTarget.setCustomValidity("");
                    }
                  },
                }}
              />
            </Box>

            <Box>
              <TextField
                id="code"
                name="code"
                fullWidth
                label={t("brand.code")}
                value={dataForm.code}
                onChange={(event) => handleChange(event, "code")}
                variant="standard"
                inputProps={{
                  pattern: "[^%*$)(\"+&?^~Â`£=!@'_/§#-]{0,}",
                  onInput: (event) => {
                    if (event.currentTarget.validity.patternMismatch) {
                      event.currentTarget.setCustomValidity(
                        t("vehicle.filterModal.regexMessage")
                      );
                    } else {
                      event.currentTarget.setCustomValidity("");
                    }
                  },
                }}
              />
            </Box>

            
          </GenericFilterBox>
        </form>
      </Box>

      <Box className="carBrandOuterTableBox">
        <Box>
        <Card >
       
        
            <Box minHeight={46} pr={1} display="flex" justifyContent={'flex-end'} alignItems="center" >
            <Tooltip  title={t("tooltipTitle.download")}>
            <IconButton color="accent" disabled ={length === 0 ?true:false} onClick={exportBrand}>
                <FileDownloadIcon/>
               </IconButton>
               </Tooltip>
          </Box>
         
        
        </Card>
        </Box>
        <Box>
          <AgGridOperationTable
            columnDefs={columns}
            onGridReady={onGridReady}
            cacheBlockSize={pageSize}
            serverSideInfiniteScroll={true}
            rowModelType={"serverSide"}
			totalElements={length}

            />

          {loading && <CustomLoader loading={loading} />}
        </Box>
      </Box>
    </Box>
  );
};
export default BrandCrudTable;
